// Waar de gebruiker na het inloggen heen gaat. ProtectedRoute geeft de
// bestemming waarop hij werd tegengehouden mee als router-state; zonder zo'n
// bestemming (gewoon inloggen, of zelf /login openen) begint hij op de
// standaardpagina.
const DEFAULT_TARGET = '/events';

export function resolveRedirectTarget(state: unknown): string {
  const from = (state as { from?: unknown } | null)?.from;
  if (typeof from !== 'string') return DEFAULT_TARGET;
  // Precies één slash: "//elders.example" en "/\elders.example" leest een
  // browser als een externe URL, en dan verlaat de gebruiker de app direct na
  // het inloggen.
  if (!from.startsWith('/') || from.startsWith('//') || from.startsWith('/\\')) {
    return DEFAULT_TARGET;
  }
  // Terug naar het loginscherm zou een lus opleveren.
  if (from === '/login') return DEFAULT_TARGET;
  return from;
}
